import { pluralizeWord } from 'modules/campaigns/lib/utils';

export const getLabelsSuccessMessage = (
  countOfCurrentLabels: number,
  countOfUpdatedLabels: number,
) => {
  const diff = countOfCurrentLabels - countOfUpdatedLabels;
  const count = Math.abs(diff);
  const label = pluralizeWord('label', count);
  if (diff < 0 || diff > countOfCurrentLabels) {
    return `Successfully added ${count} ${label}`;
  } else {
    return `Successfully removed ${count} ${label}`;
  }
};
